import { ResponsiveBar } from "@nivo/bar";
import { useNavigate } from "react-router-dom";
import Card from "../components/Reusable/Card";
import Spinner from "../components/Reusable/Spinner";
import APIS from "../constant/Endpoint";
import useGetHook from "../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useEffect, useMemo, useState } from "react";
import OverviewSkeleton from "../components/Reusable/OverviewSkeleton";

const graphTheme = {
  // Tooltip shown while hovering bar
  tooltip: {
    container: {
      background: "var(--primary-light)",
      borderRadius: "5px",
    },
  },
  text: {
    // Value writtrn inside bar
    fontSize: 20,
    fill: "#ffffff",
  },
  axis: {
    legend: {
      // X-axis and Y-axis label
      text: {
        fontSize: 16,
        fill: "var(--primary)",
      },
    },
    domain: {
      //X-axis and Y-axis main line
      line: {
        strokeWidth: 2,
        stroke: "var(--primary-light)",
      },
    },
    ticks: {
      //Small line extending left of y-axis
      line: {
        strokeWidth: 1,
        stroke: "var(--primary-light)",
      },
      //Values of Y-axis
      text: {
        fontSize: 14,
        fill: "var(--primary)",
      },
    },
  },
};

const BlogOverview = () => {
  const navigate = useNavigate();
  const [themeColor, setThemeColor] = useState("");
  const salesData = [
    { day: "Monday", Products: 120 },
    { day: "Tuesday", Products: 150 },
    { day: "Wednesday", Products: 200 },
    { day: "Thursday", Products: 170 },
    { day: "Friday", Products: 220 },
    { day: "Saturday", Products: 300 },
    { day: "Sunday", Products: 280 },
  ];
  const style = document
    .querySelector("html")
    .getAttribute("style")
    ?.split(";");

  const colorScheme = useMemo(() => {
    const colors = {};
    if (style?.length) {
      style.map((e) => {
        const values = e.split(":");
        colors[values[0].replace("--", "")] = values[1];
      });
      return colors;
    }
  }, [style]);

  const handleNavigate = (pathname: any) => {
    navigate(pathname);
  };

  const { data, isLoading } = useGetHook({
    url: APIS.BLOG_OVERVIEW,
    queryKey: ["blog-overview-page"],
  });

  useEffect(() => {
    setThemeColor(colorScheme?.["primary"]);
  }, [colorScheme]);

  return isLoading || !themeColor ? (
    <OverviewSkeleton />
  ) : (
    <>
      <div className={tw`grid grid-cols-4 gap-x-4 my-2`}>
        <Card title="Total Post" onClick={() => handleNavigate("/blog/post")}>
          <div> {data?.total_blog || 0}</div>
        </Card>
        <Card
          title="Total Author"
          onClick={() => handleNavigate("/blog/author")}
        >
          <div> {data?.total_author || 0}</div>
        </Card>
        <Card
          title="Total Category"
          onClick={() => handleNavigate("/blog/catergory")}
        >
          <div> {data?.total_category || 0}</div>
        </Card>
        <Card title="Total Tag" onClick={() => handleNavigate("/blog/tag")}>
          <div> {data?.total_tag || 0}</div>
        </Card>
      </div>
      <Card title="Statistics">
        <div className={tw`h-[600px]`}>
          <ResponsiveBar
            data={salesData}
            keys={["Products"]}
            indexBy="day"
            margin={{ top: 20, right: 130, bottom: 80, left: 80 }}
            padding={0.3}
            valueScale={{ type: "linear" }}
            indexScale={{ type: "band", round: true }}
            theme={graphTheme}
            colors={[themeColor]}
            axisBottom={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: "Day of the Week",
              legendPosition: "middle",
              legendOffset: 50,
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
              legend: "Sales",
              legendPosition: "middle",
              legendOffset: -60,
            }}
            labelSkipWidth={12}
            labelSkipHeight={12}
            legends={[
              {
                dataFrom: "keys",
                anchor: "bottom-right",
                direction: "column",
                justify: false,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: "left-to-right",
                itemOpacity: 0.85,
                symbolSize: 20,
                itemTextColor: "var(--primary)",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemOpacity: 1,
                    },
                  },
                ],
              },
            ]}
            animate={true}
          />
        </div>
      </Card>
    </>
  );
};

export default BlogOverview;
